import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaPipeModule } from '../../pipes';
import { CampanhaROIWidgetsModule } from '../../roi/components/widgets';
import { CampanhaStatusModule } from '../../status';
import { PacoteCampanhaPipeModule } from '../../../pacotes/pipes';

import { CampanhaROIChartTableComponent } from './table';
import { CampanhaROIChartComponent } from './campanha-roi-chart.component';


@NgModule({
    imports: [
        SharedModule,
        CampanhaPipeModule,
        CampanhaROIWidgetsModule,
        CampanhaStatusModule,
        PacoteCampanhaPipeModule
    ],
    declarations: [
        CampanhaROIChartTableComponent,
        CampanhaROIChartComponent
    ],
    exports: [
        CampanhaROIChartComponent
    ]
})
export class CampanhaROIChartModule { }
